<template>
	<div class="screen game" :class="user.first_times.tuto ? 'tuto tuto-step-' + game.tuto_step : ''">
		
		<transition name="opacity">
			<div v-show="game.status" class="game-header">
				<score />
				<v-touch @tap="show_about()" class="button-info"><icon file="info" :size="24" /></v-touch>
				<v-touch @tap="show_options()" class="button-menu"><icon file="menu" :size="24" /></v-touch>
			</div>
		</transition>
		
		<transition name="slideup">
			<div v-show="game.status" class="game-content">
				<div class="life">
					<div v-for="i in game.config.life_max" class="dot" :class="i > game.life ? 'empty' : 'full'"></div>
					<tuto-info :step="4"></tuto-info>
				</div>

				<transition name="opacity" mode="in-out">
					<board v-show="game.status == 'playing'" />
				</transition>

				<transition name="opacity" mode="in-out">
					<end v-if="game.status == 'lose'" />
				</transition>

			</div>
		</transition>
		
		<transition name="opacity">
			<div v-if="show_tuto && user.first_times.tuto" class="game-tuto-bg"></div>
		</transition>
		<tuto-info v-if="show_tuto" :step="1"></tuto-info>
		<tuto-info :step="7"></tuto-info>
		<tuto-info :step="11"></tuto-info>

		<card-info></card-info>

	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import Board from './game/Board'
import Score from './game/Score'
import End from './game/End'
import TutoInfo from './game/TutoInfo'
import CardInfo from './game/CardInfo'

export default {
	name: 'Game',
	data () {
		return {
			show_tuto: false
		}
	},
	computed: Object.assign(mapGetters([ 'user', 'game', 'board' ]), {
		
	}),
	watch: {
		'game.status': function(newValue, oldValue) {
			var that = this
			setTimeout(function() {
				if (that.user.first_times.tuto) that.show_tuto = true
			}, 500)
		}
	},
	methods: {
		show_options: function() {
			this.$store.dispatch('set_options_visible', { visible: true })
		},
		show_about: function() {
			this.$store.dispatch('set_about_visible', { visible: true })
		}
	},
	mounted: function() {
		// this.$store.dispatch('start_game')
	},
	components: { Board, Score, End, TutoInfo, CardInfo }
}
</script>

<style lang="stylus">
@import '../assets/css/app'





	
.slideup-enter-active, .slideup-leave-active
	transition 0.5s easeOutQuart
.slideup-enter, .slideup-leave-to
	// opacity 0
	transform translate3D(0, 80%, 0) rotateX(-80deg) 


	
.opacity-enter-active, .opacity-leave-active
	transition 0.25s easeOutQuart
.opacity-enter, .opacity-leave-to
	opacity 0

	


.game
	// background-color dark
	// background linear-gradient(to top, lighten(dark, 10%), darken(dark, 10%))
	// background linear-gradient(to top, #cc95c0, #dbd4b4, #7aa1d2)
	// background linear-gradient(30deg, #d6a4a4, #dae2f8)
	perspective 1000px
	// background-color: #ff9d00;
	// background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100%25' height='100%25' viewBox='0 0 1600 800'%3E%3Cg stroke='%23000' stroke-width='66.7' stroke-opacity='0.05' %3E%3Ccircle fill='%23ff9d00' cx='0' cy='0' r='1800'/%3E%3Ccircle fill='%23fb8d17' cx='0' cy='0' r='1700'/%3E%3Ccircle fill='%23f47d24' cx='0' cy='0' r='1600'/%3E%3Ccircle fill='%23ed6e2d' cx='0' cy='0' r='1500'/%3E%3Ccircle fill='%23e35f34' cx='0' cy='0' r='1400'/%3E%3Ccircle fill='%23d85239' cx='0' cy='0' r='1300'/%3E%3Ccircle fill='%23cc453e' cx='0' cy='0' r='1200'/%3E%3Ccircle fill='%23be3941' cx='0' cy='0' r='1100'/%3E%3Ccircle fill='%23b02f43' cx='0' cy='0' r='1000'/%3E%3Ccircle fill='%23a02644' cx='0' cy='0' r='900'/%3E%3Ccircle fill='%23901e44' cx='0' cy='0' r='800'/%3E%3Ccircle fill='%23801843' cx='0' cy='0' r='700'/%3E%3Ccircle fill='%236f1341' cx='0' cy='0' r='600'/%3E%3Ccircle fill='%235e0f3d' cx='0' cy='0' r='500'/%3E%3Ccircle fill='%234e0c38' cx='0' cy='0' r='400'/%3E%3Ccircle fill='%233e0933' cx='0' cy='0' r='300'/%3E%3Ccircle fill='%232e062c' cx='0' cy='0' r='200'/%3E%3Ccircle fill='%23210024' cx='0' cy='0' r='100'/%3E%3C/g%3E%3C/svg%3E");
	// background-attachment: fixed;
	&.tuto
		&.tuto-step-2, &.tuto-step-6
			.game-header .score
				z-index 3
		&.tuto-step-3
			.game-content .board .slot.slot-1
				z-index 3
		&.tuto-step-4
			.game-content .life
				z-index 3
		&.tuto-step-5
			.game-content .board .slot.slot-5
				z-index 3
		&.tuto-step-8
			.game-content .board .slot.slot-15
				z-index 3
		&.tuto-step-9
			.game-content .board .slot.slot-8
				z-index 3
		.game-tuto-bg
			position absolute
			left 0
			top 0
			right 0
			height 100%
			z-index 2
			background alpha(#000, 30%)
		.game-content .board .slot
			&:active
				transform none
			

	.game-header
		position absolute
		left 0
		right 0
		top 0
		// background red
		height calc(100% - (452px + 50px))
		text-align center
		.button-info, .button-menu
			position absolute
			top 0
			width 56px
			height 56px
			line-height 56px
			color #fff
			display flex
			align-items center
			justify-content center
			opacity 0.5
			.icon
				display block
		.button-info
			left 0
		.button-menu
			right 0
	.game-content
		position absolute
		left 16px
		right 16px
		bottom 16px
		border-radius 16px
		height ((card_height + 4px) * 4 + 4 + 100px)
		// padding-bottom 40px
		display flex
		align-items center
		justify-content center
		flex-direction column
		// background alpha(light, 50%)
		background light
		// box-shadow inset 0 0 0 2px light, 0 0 0 2px light
		box-shadow 0 -2px 0 2px darken(dark, 15%)
		.life
			position absolute
			left 50%
			top 0
			transform translate3D(-50%, -100%, 0)
			height 32px
			// width ((16px + 8px) * 5 + 48px)
			padding 0 20px
			width auto
			background light
			background alpha(light, 50%)
			background light
			// border-radius 16px
			border-top-left-radius 16px
			border-top-right-radius 16px
			display flex
			align-items flex-end
			justify-content center
			box-shadow 0 -2px 0 2px darken(dark, 15%)
			&:before
				content ''
				position absolute
				left 0
				right 0
				top 100%
				height 16px
				background light
				border-bottom-left-radius 16px
				border-bottom-right-radius 16px
			.dot
				display inline-block
				width 16px
				height 16px
				// border-radius 100%
				border-radius 6px
				transform rotate(45deg)
				margin 0 6px
				transition 0.25s easeOutQuart
				background-color lighten(dark, 15%)
				background-color dark
				&:nth-child(1)
					transition-delay 0
				&:nth-child(2)
					transition-delay 0.05s
				&:nth-child(3)
					transition-delay 0.1s
				&:nth-child(4)
					transition-delay 0.15s
				&.empty
					opacity 0
					transform rotate(45deg) scale(2)


// Small height
@media (max-height: 620px)
	.game
		.game-header
			height calc(100% - (412px + 30px))
			.score
				font-size 48px
				height @font-size
				line-height @font-size
		.game-content
			height ((card_height + 4px) * 4 + 4 + 50px)

// Small width
@media (max-width: 359px)
	.game
		.game-content
			left 0
			right 0
			bottom 0
			border-radius 0
			
// big width
@media (min-width: 420px)
	.game
		.game-content
			left calc(50% - (390px / 2))
			right auto
			width 390px
			// transform translate3D(-50%, 0, 0)

// Big height
@media (min-height: 700px)
	.game
		.game-header
			height calc(100% - (452px + 50px + 64px))
		.game-content
			bottom 64px
		
// Big height
@media (min-height: 780px)
	.game
		.game-header
			height calc(100% - (452px + 50px + 96px))
		.game-content
			bottom 96px

</style>



// WEBPACK FOOTER //
// src/components/Game.vue